import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getCallsList } from "../../Redux/Slice/Contacts/GetCallsSlice";
import { CallIcon } from "../../Assets/svgs/CallIcon";
import { CallListIcon } from "../../Assets/svgs/CallListIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { getCallsById } from "../../Redux/Slice/Contacts/GetCallByIdSlice";
import { DeleteCall } from "../../Redux/Slice/Contacts/DeleteCallSlice";
import { Loader } from "../../Common/Loader";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";
import { ConfirmModel } from "../../Model/ConfirmModel";
import ImageIcon from "../../Assets/images/VoxApp-Icon.png";
import { dateFormat } from "../../Common/DateAndTimeFormat";

export const Calls = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedtab, setSelectedTab] = useState(1);
  const [callsList, setCallsList] = useState([]);
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [selectedCall, setSelectedcall] = useState();
  const [confirmModel, setCOnfirmModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const tabs = [
    { key: 1, filter: "upcoming" },
    { key: 2, filter: "scheduled" },
    { key: 3, filter: "completed" },
  ];
  const changeTab = (value) => {
    setSelectedTab(value);
    getCalls(value);
  };
  useEffect(() => {
    getCalls(1);
  }, []);

  const getCalls = async (tab) => {
    const filterVal = tabs.find((x) => x.key === tab).filter;
    let contactId = location.pathname.split("/")[2];
    const result = await dispatch(
      getCallsList({
        filter: filterVal,
        contactId: props?.isForContactGroup ? "" : contactId,
        contactGroupId: props?.isForContactGroup ? contactId : "",
      })
    );
    setCallsList(result?.payload?.data);
  };

  const dateTimeFormat = (dateString, timeString) => {
    // Parse the ISO date
    const date = new Date(dateString);
    // Split the time string into hours, minutes, and seconds
    const [hours, minutes, seconds] = timeString.split(":").map(Number);

    // Set the time on the date object in UTC
    date.setHours(hours, minutes, seconds);
    // Define options for formatting
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };

    // Format the date without a comma
    const formattedDate = dateFormat(dateString);

    // Format the time (12-hour format with AM/PM)
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    // Combine and return the final output
    return `${formattedDate} ${formattedTime}`;
  };

  function timeLeft(dateString, timeString) {
    // Parse the ISO date
    const targetDate = new Date(dateString);

    // Split the time string into hours, minutes, and seconds
    const [hours, minutes, seconds] = timeString.split(":").map(Number);

    // Set the target time on the date object
    targetDate.setUTCHours(hours, minutes, seconds);

    // Get the current date and time
    const now = new Date();

    // Calculate the difference in milliseconds
    const difference = targetDate - now;

    // If the difference is negative, return '0:00' (time has passed)
    if (difference < 0) {
      return "0:00";
    }

    // Calculate hours and minutes left
    const totalMinutes = Math.floor(difference / (1000 * 60));
    const leftHours = Math.floor(totalMinutes / 60);
    const leftMinutes = totalMinutes % 60;

    // Format the output
    return `${String(leftHours).padStart(2, "0")}:${String(
      leftMinutes
    ).padStart(2, "0")}`;
  }

  const getChatHistory = async (call) => {
    const result = await dispatch(getCallsById(call.id));
  };

  const deleteCall = async () => {
    setCOnfirmModel(false);
    const result = await dispatch(DeleteCall(selectedCall.id));

    if (
      DeleteCall.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      setSuccessMessage("Call Deleted Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        navigate(-1);
      }, 1500);
    } else {
      //TODO: error popup here
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  return (
    <div className="CreateScheduleCall__row">
      {isLoading ? <Loader /> : ""}
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
      {successModel ? <SuccessModel message={successMessage} /> : ""}
      {confirmModel ? (
        <ConfirmModel
          onAccept={deleteCall}
          onReject={() => {
            setCOnfirmModel(false);
          }}
          title="Delete Call!"
          message="Are you sure you want to Delete the call?"
        />
      ) : (
        ""
      )}
      <div className="CreateScheduleCall__row__col">
        <div className="CreateScheduleCall__card">
          <div className="CreateScheduleCall__card__head">All Calls</div>
          <div className="CreateScheduleCall__card__body p_0">
            <div className="tabsWrap">
              <ul className="tabs">
                <li
                  className={
                    selectedtab === 1
                      ? "tabs__link tabs__link--selected"
                      : "tabs__link"
                  }
                  onClick={() => changeTab(1)}
                >
                  Upcoming Calls
                </li>
                <li
                  className={
                    selectedtab === 2
                      ? "tabs__link tabs__link--selected"
                      : "tabs__link"
                  }
                  onClick={() => changeTab(2)}
                >
                  Scheduled Calls
                </li>
                <li
                  className={
                    selectedtab === 3
                      ? "tabs__link tabs__link--selected"
                      : "tabs__link"
                  }
                  onClick={() => changeTab(3)}
                >
                  Completed Calls
                </li>
              </ul>
            </div>
            <div className="tabsContent">
              <div className="tabsContent__content tabsContent__content--selected">
                <div className="scheduledCallList">
                  {callsList && callsList.length > 0 ? (
                    callsList.map((call) => (
                      <div className="scheduledCallList__item">
                        <div className="scheduledCallList__card">
                          <div className="scheduledCallList__card__head">
                            <div className="profile">
                              <div className="icon">
                                <CallListIcon />
                              </div>
                              <div className="info">
                                <h4 className="name">{call.description}</h4>
                                <p className="para">
                                  {dateTimeFormat(call.date, call.startTime)}
                                </p>
                              </div>
                            </div>
                            {selectedtab !== 3 ? (
                              <div className="btn__group">
                                <button
                                  className="btn"
                                  onClick={() => props.onEdit(call)}
                                >
                                  <svg
                                    width="17"
                                    height="18"
                                    viewBox="0 0 17 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M11.8898 2.70245C12.0734 2.51876 12.2915 2.37304 12.5315 2.27363C12.7715 2.17421 13.0288 2.12305 13.2886 2.12305C13.5483 2.12305 13.8056 2.17421 14.0456 2.27363C14.2856 2.37304 14.5037 2.51876 14.6874 2.70245C14.8711 2.88615 15.0168 3.10422 15.1162 3.34423C15.2156 3.58424 15.2668 3.84148 15.2668 4.10126C15.2668 4.36105 15.2156 4.61828 15.1162 4.85829C15.0168 5.0983 14.8711 5.31638 14.6874 5.50007L5.24541 14.942L1.39868 15.9911L2.44779 12.1444L11.8898 2.70245Z"
                                      stroke="#0F172A"
                                      stroke-width="1.39881"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </button>
                                <button
                                  className="btn"
                                  onClick={() => {
                                    setSelectedcall(call);
                                    setCOnfirmModel(true);
                                  }}
                                >
                                  <svg
                                    width="17"
                                    height="18"
                                    viewBox="0 0 17 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M2.3125 4.80348H3.71131M3.71131 4.80348H14.9018M3.71131 4.80348V14.5951C3.71131 14.9661 3.85868 15.3219 4.12101 15.5843C4.38334 15.8466 4.73913 15.994 5.11012 15.994H12.1042C12.4752 15.994 12.8309 15.8466 13.0933 15.5843C13.3556 15.3219 13.503 14.9661 13.503 14.5951V4.80348H3.71131ZM5.80952 4.80348V3.40467C5.80952 3.03368 5.9569 2.67789 6.21923 2.41556C6.48155 2.15323 6.83735 2.00586 7.20833 2.00586H10.006C10.3769 2.00586 10.7327 2.15323 10.9951 2.41556C11.2574 2.67789 11.4048 3.03368 11.4048 3.40467V4.80348M7.20833 8.3005V12.4969M10.006 8.3005V12.4969"
                                      stroke="#D4001C"
                                      stroke-width="1.39881"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </button>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="scheduledCallList__card__body">
                            <h5 className="title">Participants</h5>
                            <div className="participant">
                              {call.participants
                                ? call.participants.map((participant) => {
                                    if (participant.assistant) {
                                      return (
                                        <div className="participant__item">
                                          <div className="participant__profile">
                                            <div className="initials">
                                              <img
                                                src={participant?.assistant?.avatar || ImageIcon}
                                                alt=""
                                              />
                                            </div>
                                            <div className="info">
                                              <h4 className="name">
                                                {participant.assistant
                                                  ? participant.assistant.name
                                                  : participant.contact
                                                      .firstName
                                                  ? participant.contact
                                                      .firstName +
                                                    " " +
                                                    participant.contact.lastName
                                                  : participant.contact.name}
                                              </h4>
                                              <p className="para">
                                                {participant.assistant
                                                  ? "Assistant"
                                                  : "Contact"}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    } else {
                                      return "";
                                    }
                                  })
                                : ""}
                              {call.participants
                                ? call.participants.map((participant) => {
                                    if (participant.contact) {
                                      return (
                                        <div className="participant__item">
                                          <div className="participant__profile">
                                            <div className="initials">
                                              <img
                                                src={participant?.contact?.avatar || ImageIcon}
                                                alt=""
                                              />
                                            </div>
                                            <div className="info">
                                              <h4 className="name">
                                                {participant.assistant
                                                  ? participant.assistant.name
                                                  : participant.contact
                                                      .firstName
                                                  ? participant.contact
                                                      .firstName +
                                                    " " +
                                                    participant.contact.lastName
                                                  : participant.contact.name}
                                              </h4>
                                              <p className="para">
                                                {participant.assistant
                                                  ? "Assistant"
                                                  : "Contact"}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    } else {
                                      return "";
                                    }
                                  })
                                : ""}
                            </div>
                          </div>
                          {selectedtab === 1 ? (
                            ""
                          ) : // <div className="scheduledCallList__card__footer">
                          //   <div className="btn__group">
                          //     <button className="btn btn__primary" disabled>
                          //       Join
                          //     </button>
                          //   </div>
                          //   <div className="status status--start">
                          //     Ongoing Call
                          //   </div>
                          // </div>
                          selectedtab === 3 ? (
                            <div className="scheduledCallList__card__footer">
                              <div className="btn__group">
                                <button
                                  className="btn btn__primary"
                                  onClick={() => {
                                    const assistant = Array.isArray(call?.participants) ? call.participants?.find((p)=>p?.assistant && p?.assistant?.id) : null;
                                    const contact = Array.isArray(call?.participants) ? call.participants?.find((p)=>p?.contact && p?.contact?.id) : null;
                                    if(assistant && contact) {
                                      navigate("/chat",{
                                        state:{
                                          assistantId: assistant?.assistant?.id,
                                          contactId: contact?.contact?.id,
                                        }
                                      });
                                    } 
                                    // getChatHistory(call);                                
                                  }}
                                >
                                  View Chat
                                </button>
                              </div>
                              {/* <div className="status status--complete">
                                  Completed
                                </div> */}
                            </div>
                          ) : (
                            ""
                            // <div className="scheduledCallList__card__footer">
                            //   <div className="btn__group">
                            //     <button disabled className="btn btn__primary">
                            //       Join
                            //     </button>
                            //   </div>
                            //    <div className="status">
                            //     Starts in{" "}
                            //     {timeLeft(call.date, call.startTime)} hours
                            //   </div>
                            // </div>
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        justifyContent: "center",
                      }}
                    >
                      No Calls{" "}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
